<template>
  <div class="single_question">
    <div class="question_title">
      <span>{{questionData.sectionName === undefined ? "" : questionData.sectionName}}</span>
      <span>({{questionData.sectionPrompt+"  本题"+questionData.score+"分。"}})</span>
    </div>
    <div class="title">
      <div v-if="questionData.questionContent" class=" editorShowArea ql-editor title_one" v-html="questionData.questionContent"></div>
      <h3 style="overflow: auto;" class=" editorShowArea ql-editor" v-html="questionData.questionDto.questionContent"></h3>
    </div>
    <div class="single_item" v-for="(data,index) in questionData.questionDto.items">
      <el-checkbox @change="save()" class="single_radio" v-model="checked[index]" :disabled="disabledFlag">{{null}}</el-checkbox>
      <span style="float: left;flex:none;" class="single_title editorShowArea ql-editor" v-html="data.itemKey"></span>
      <span class="single_title  editorShowArea ql-editor" v-html="data.itemValue"></span>
    </div>
  </div>
</template>

<script>
    import {moduleId} from "../../../../../store/modules/exam";
    import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';
    export default {
        name: "more",
        data() {
            return {
                checked:[false,false,false,false,false,false,false,false],
								disabledFlag: true
            };
        },
        computed:{
            ...mapState(moduleId, {
                questionData: state => state.questionData,
                paperData: state => state.paperData,
                preAnswer: state => state.preAnswer,
            }),
        },
        watch:{
            checked(newVal){

            },
            preAnswer(newVal){
                 let that = this;
              that.checked = [false,false,false,false,false,false,false,false];
                if(newVal !== null){
									this.disabledFlag = false
                    newVal.answer.split(",").forEach((item)=>{
                      if(item === "A"){
                        that.$set(that.checked,0,true);
                      }else if(item === "B"){
                        that.$set(that.checked,1,true);
                      }else if(item === "C"){
                        that.$set(that.checked,2,true);
                      }else if(item === "D"){
                        that.$set(that.checked,3,true);
                      }else if(item === "E"){
                        that.$set(that.checked,4,true);
                      }else if(item === "F"){
                        that.$set(that.checked,5,true);
                      }else if(item === "G"){
                        that.$set(that.checked,6,true);
                      }else if(item === "H"){
                          that.$set(that.checked,7,true);
                      }
                    })
                }else{
                    this.checked = [false,false,false,false,false,false,false,false];
										this.disabledFlag = true
                }


            }
        },
        methods:{
            ...mapActions(moduleId,['saveAnswer']),
            save(){
                let str = '';
                this.checked.forEach((item,index)=>{
                    if(item === true && index === 0){
                        str+= 'A,';
                    }else if(item === true && index === 1){
                        str+= 'B,';
                    }else if(item === true && index === 2){
                        str+= 'C,';
                    }else if(item === true && index === 3){
                        str+= 'D,';
                    }else if(item === true && index === 4){
                      str+= 'E,';
                    }else if(item === true && index === 5){
                      str+= 'F,';
                    }else if(item === true && index === 6){
                      str+= 'G,';
                    }else if(item === true && index === 7){
                        str+= 'H,';
                    }
                });
                let obj = {
                  "examPaperId":this.paperData.examPaperId,
                  "subjectId":localStorage.getItem("subjectId"),
                  "classId":this.$route.query.classId,
                  "courseId":this.$route.query.id,
                  "paperCode":this.$route.query.paperCode,
                  "paperId":this.$route.query.paperId,
                  "questionId":this.questionData.questionId,
                  "questionType":2,
                  "version":1,
                  "userAnswer":str.substring(0,str.length-1),
                  "score":this.questionData.score,
                  "questionStatus":0,
                  "useTime":"23",
                  "type":this.$route.query.type
                };
                this.saveAnswer(obj);
            }
        }
    }
</script>

<style lang="scss" scoped>
  .single_question {
    background: white;
    height: 100%;
     .question_title{
      margin-left: 30px;
      padding-top:30px;
      span:nth-child(1){
        font-size:18px;
        font-weight: bold;
      }
      span:nth-child(2){
        font-size:12px;
        font-weight: 500;
        margin-left: 12px;
      }
    }
    .title{
      .title_one{
        border-bottom: 1px dashed black;
        width: 95%;
        margin:auto;
      }
      .ql-editor{
        max-width: 95%;
        overflow: auto!important;
        margin:auto;
      }
      /deep/ .ql-editor img{
        max-width: 100% !important;
      }
    }
  .single_item {
    margin-left: 50px;
    display: flex;
    line-height: 50px;

  .single_radio {
    float: left;
    margin-right: 5px!important;
  }

  .single_title {
    display: inline-block;
    /*margin-left:10px;*/
    /*padding: 0;*/
  }
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testComponent/more.vue